<div class="shared-popover-wrapper">
  <p-overlayPanel
    #popoverRef
    styleClass="shared-popover-default"
    [dismissable]="dismissable"
    [showCloseIcon]="false"
    [appendTo]="'body'"
  >
    <ng-container *ngTemplateOutlet="content" />
  </p-overlayPanel>
</div>
